import { ObservableMap } from 'mobx';
import type { ProjectId, TimeStreamProject, AssetId, TimeStreamAsset } from '../../schema';
import getProjectIdInfo from '../../utils/getProjectIdInfo';

export default function newTimeStreamProject(projectId: ProjectId): TimeStreamProject {
    const { tenant, mailbox, outlookSpaceId, isShared } = getProjectIdInfo(projectId);
    return {
        // required PatchOutlookSpace fields
        name: '',
        description: '',
        categories: [],
        keywords: [],
        people: [],
        image: '',
        tasksParentFolderId: '',
        unseenCapturedCount: 0,
        templateType: '',
        appName: '',

        // OutlookSpace fields, except the ones omitted by TimeStreamProject
        createdDateTime: '',
        lastModifiedDateTime: '',

        // TimeStreamProject fields from project ID
        tenant,
        mailbox,
        isShared,
        projectId,
        outlookSpaceId,

        // Other TimeStreamProject fields
        outlookSpaceKey: null,
        assets: new ObservableMap<AssetId, TimeStreamAsset>(),
        renderingOrder: [],
        deleted: false,
        newlyCreated: false,
        loaded: false,
        isLoading: false,
        loadingFailed: false,
        pendingLoad: false,
        isPreview: false,
        canSync: false,
        skipToken: '',
        deltaToken: '',
    };
}
